import { gql } from "@apollo/client";

const createMutation = async (client, mutationName, mutation, variables = {}) => {
  const { data } = await client.mutate({
    mutation,
    variables,
  });
  return data[mutationName] || {};
};

const CREATE_APPLICATION = gql`
mutation CreateApplication($input: CandidateDetailInput, $opportunityId: Int, $sourceInfo: String) {
  createApplication(input: $input, opportunity_id: $opportunityId, source_info: $sourceInfo) {
    status
    id_affected
    errMsg
  }
}
`;

export const createApplication = async (client, input, opportunity_id, source_info) => {
  try {
    const result = await createMutation(client, "createApplication", CREATE_APPLICATION, {
      input,
      opportunityId: opportunity_id,
      sourceInfo: source_info,
    });
    return result;
  } catch (error) {
    return { response: { errMsg: error } };
  }
};

const LOGIN_CANDIDATE = gql`
  mutation LoginCandidate($email: String!, $password: String!) {
    loginCandidate(email: $email, password: $password) {
      response {
        status
        errMsg
        id_affected
      }
      token
    }
  }
`;

export const loginCandidate = async (client, { email, password }) => {
  try {
    const result = await createMutation(client, "loginCandidate", LOGIN_CANDIDATE, {
      email,
      password,
    });
    return result;
  } catch (error) {
    return { response: { errMsg: error + "" } };
  }
};

const SCORING_CFIT = gql`
  mutation ScoringCFIT($input: [CFITInputScore]) {
    scoringCFIT(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const ScoringCFIT = async (client, input) => {
  try {
    const result = await createMutation(client, "scoringCFIT", SCORING_CFIT, {
      input,
    });
    return result;
  } catch (error) {
    return { errMsg: error };
  }
};

const SCORING_PAPIKOSTIK = gql`
  mutation ScoringPapikostik($input: [ScoringPapikostik]) {
    scoringPapikostik(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const scoringPapikostik = async (client, input) => {
  try {
    const result = await createMutation(client, "scoringPapikostik", SCORING_PAPIKOSTIK, {
      input,
    });
    return result || [];
  } catch (error) {
    return { errMsg: error };
  }
};

const UPDATE_CFIT_SECTIONDATE = gql`
  mutation UpdateCFITSectionDate($section: Int!) {
    updateCFITSectionDate(section: $section) {
      status
      errMsg
      id_affected
    }
  }
`;

export const updateCFITSectionDate = async (client, section) => {
  try {
    const result = await createMutation(client, UPDATE_CFIT_SECTIONDATE, "UpdateCFITSectionDate", {
      section,
    });
    return result;
  } catch (error) {
    return { errMsg: error };
  }
};

const PRE_ASSESMENT_CANDIDATE = gql`
  mutation CreateCandidatePreAssessment($input: CandidatePreAssessmentInput) {
    createCandidatePreAssessment(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const CreateCandidatePreAssessment = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "createCandidatePreAssessment",
      PRE_ASSESMENT_CANDIDATE,
      { input }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const RESEND_OTP = gql`
  mutation SendOTP($input: ResendOTPInput!) {
    sendOTP(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const sendOTP = async (client, input) => {
  try {
    const result = await createMutation(client, "sendOTP", RESEND_OTP, {
      input,
    });
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const UPDATE_PASSWORD_CANDIDATE = gql`
  mutation UpdatePasswordCandidate($email: String!, $password: String!) {
    updatePasswordCandidate(email: $email, password: $password) {
      status
      errMsg
      id_affected
    }
  }
`;

export const updatePasswordCandidate = async (client, { email, password }) => {
  try {
    const result = await createMutation(
      client,
      "updatePasswordCandidate",
      UPDATE_PASSWORD_CANDIDATE,
      { email, password }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const INSERT_LOG_CFIT = gql`
  mutation InsertLogCFIT(
    $cfitSecondRemaining: Int!
    $input: [LogCFITInput]
    $showInstruction: Boolean
    $isSection1Done: Boolean
    $isSection2Done: Boolean
    $isSection4Done: Boolean
    $isSection3Done: Boolean
  ) {
    insertLogCFIT(
      cfit_second_remaining: $cfitSecondRemaining
      input: $input
      show_instruction: $showInstruction
      isSection1Done: $isSection1Done
      isSection2Done: $isSection2Done
      isSection4Done: $isSection4Done
      isSection3Done: $isSection3Done
    ) {
      status
      errMsg
      id_affected
    }
  }
`;

export const insertLogCFIT = async (
  client,
  {
    show_instruction,
    cfit_second_remaining,
    data,
    isSection1Done,
    isSection2Done,
    isSection3Done,
    isSection4Done,
  }
) => {
  try {
    const result = await createMutation(client, "insertLogCFIT", INSERT_LOG_CFIT, {
      cfitSecondRemaining: cfit_second_remaining,
      showInstruction: show_instruction,
      input: data,
      isSection1Done: isSection1Done,
      isSection2Done: isSection2Done,
      isSection4Done: isSection4Done,
      isSection3Done: isSection3Done,
    });
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const INSERT_LOG_PAPIKOSTIK = gql`
  mutation InsertLogPapikostik($input: [LogPapipkostikInput]) {
    insertLogPapikostik(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const insertLogPapikostik = async (client, input) => {
  try {
    const result = await createMutation(client, "insertLogPapikostik", INSERT_LOG_PAPIKOSTIK, {
      input,
    });
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const UPDATE_PROFILE_CANDIDATE = gql`
  mutation UpdateProfileCandidate($input: CandidateProfileInput) {
    updateProfileCandidate(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const updateProfileCandidate = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "updateProfileCandidate",
      UPDATE_PROFILE_CANDIDATE,
      { input }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const CREATE_CANDIDATE_EXPERIENCE = gql`
  mutation CreateCandidateExperience($input: CandidateExperiencesInput) {
    createCandidateExperience(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const createCandidateExperience = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "createCandidateExperience",
      CREATE_CANDIDATE_EXPERIENCE,
      { input }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const CREATE_CANDIDATE_EDUCATION = gql`
  mutation CreateCandidateEducation($input: CandidateEducationInput) {
    createCandidateEducation(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const createCandidateEducation = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "createCandidateEducation",
      CREATE_CANDIDATE_EDUCATION,
      { input }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const CREATE_CANDIDATE_COURSE = gql`
  mutation CreateCandidateCourse($input: CandidateCourseInput) {
    createCandidateCourse(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const createCandidateCourse = async (client, input) => {
  try {
    const result = await createMutation(client, "createCandidateCourse", CREATE_CANDIDATE_COURSE, {
      input,
    });
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const UPDATE_CANDIDATE_SKILL = gql`
  mutation UpdateSkillProfileCandidate($input: [String]) {
    updateSkillProfileCandidate(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const updateSkillProfileCandidate = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "updateSkillProfileCandidate",
      UPDATE_CANDIDATE_SKILL,
      { input }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const UPDATE_CANDIDATE_EXPERIENCE_BY_ID = gql`
  mutation UpdateCandidateExperienceByID($input: CandidateExperiencesInputUpdate) {
    updateCandidateExperienceByID(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const updateCandidateExperienceByID = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "updateCandidateExperienceByID",
      UPDATE_CANDIDATE_EXPERIENCE_BY_ID,
      { input }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const UPDATE_CANDIDATE_EDUCATION_BY_ID = gql`
  mutation UpdateCandidateEducationByID($input: CandidateEducationInputUpdate) {
    updateCandidateEducationByID(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const updateCandidateEducationByID = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "updateCandidateEducationByID",
      UPDATE_CANDIDATE_EDUCATION_BY_ID,
      { input }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const UPDATE_CANDIDATE_COURSE_BY_ID = gql`
  mutation UpdateCandidateCourseByID($input: CandidateCourseInputUpdate) {
    updateCandidateCourseByID(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const updateCandidateCourseByID = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "updateCandidateCourseByID",
      UPDATE_CANDIDATE_COURSE_BY_ID,
      { input }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const UPDATE_CV_CANDIDATE = gql`
  mutation UpdateCVCandidate($linkCv: String!) {
    updateCVCandidate(link_cv: $linkCv) {
      status
      id_affected
      errMsg
    }
  }
`;

export const updateCVCandidate = async (client, linkCv) => {
  try {
    const result = await createMutation(client, "updateCVCandidate", UPDATE_CV_CANDIDATE, {
      linkCv: linkCv,
    });
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const DELETE_EXPERIENCE_CANDIDATE_BY_ID = gql`
  mutation DeleteCandidateExperienceByID($deleteCandidateExperienceByIdId: Int!) {
    deleteCandidateExperienceByID(id: $deleteCandidateExperienceByIdId) {
      status
      errMsg
      id_affected
    }
  }
`;

export const deleteCandidateExperienceByID = async (client, id) => {
  try {
    const result = await createMutation(
      client,
      "deleteCandidateExperienceByID",
      DELETE_EXPERIENCE_CANDIDATE_BY_ID,
      { deleteCandidateExperienceByIdId: id }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const DELETE_EDUCATION_CANDIDATE_BY_ID = gql`
  mutation DeleteCandidateEducationByID($deleteCandidateEducationByIdId: Int!) {
    deleteCandidateEducationByID(id: $deleteCandidateEducationByIdId) {
      status
      errMsg
      id_affected
    }
  }
`;

export const deleteCandidateEducationByID = async (client, id) => {
  try {
    const result = await createMutation(
      client,
      "deleteCandidateEducationByID",
      DELETE_EDUCATION_CANDIDATE_BY_ID,
      { deleteCandidateEducationByIdId: id }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const DELETE_COURSE_CANDIDATE_BY_ID = gql`
  mutation DeleteCandidateCourseByID($deleteCandidateCourseByIdId: Int!) {
    deleteCandidateCourseByID(id: $deleteCandidateCourseByIdId) {
      status
      errMsg
      id_affected
    }
  }
`;

export const deleteCandidateCourseByID = async (client, id) => {
  try {
    const result = await createMutation(
      client,
      "deleteCandidateCourseByID",
      DELETE_COURSE_CANDIDATE_BY_ID,
      { deleteCandidateCourseByIdId: id }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const ADD_CANDIDATE_TO_OPPORTUNITY = gql`
  mutation AddCandidateToOpportunity($opportunityId: Int!) {
    addCandidateToOpportunity(opportunity_id: $opportunityId) {
      status
      errMsg
      id_affected
    }
  }
`;

export const addCandidateToOpportunity = async (client, id) => {
  try {
    const result = await createMutation(
      client,
      "addCandidateToOpportunity",
      ADD_CANDIDATE_TO_OPPORTUNITY,
      { opportunityId: id }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const CREATE_SKILL = gql`
  mutation CreateSkill($input: SkillInput) {
    createSkill(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const createSkill = async (client, input) => {
  try {
    const result = await createMutation(client, "createSkill", CREATE_SKILL, {
      input: { skill: input },
    });
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const UPDATE_ADDITIONALINFORMATION = gql`
  mutation UpdateCandidateAdditionalInformation($input: CandidateAdditionalInfoInput) {
    updateCandidateAdditionalInformation(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const UpdateCandidateAdditionalInformation = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "updateCandidateAdditionalInformation",
      UPDATE_ADDITIONALINFORMATION,
      { input }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const UPDATE_CANDIDATE_EMAIL_PHONE_NUMBER = gql`
  mutation UpdateCandidateEmailPhoneNumber($input: candidateEmailNumberUpdate) {
    updateCandidateEmailPhoneNumber(input: $input) {
      status
      errMsg
      id_affected
    }
  }
`;

export const updateCandidateEmailPhoneNumber = async (client, input) => {
  try {
    const result = await createMutation(
      client,
      "updateCandidateEmailPhoneNumber",
      UPDATE_CANDIDATE_EMAIL_PHONE_NUMBER,
      { input }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};
